import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FreeRoundsScreenView} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenView';
import {FreeRoundsScreenModule} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenModule';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';

export class FreeRoundsResumeState extends ModuleState<FreeRoundsScreenView, FreeRoundsScreenModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(FreeRoundsScreenView.KEEP_IT_PRESSED, this.onKeepItPressed);
	}

	protected onKeepItPressed(): void {
		const logic: RecodeLogic = this.module.logic as RecodeLogic;
		if (logic.hasFreeGames()) {
			this.view.showRestoreScreen(logic.currentFreeGameProgress, true);
		} else {
			throw new Error('FreeRoundsResumeState::onKeepItPressed no free games on next offer');
		}

	}

}


// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/microgaming/freerounds/states/FreeRoundsResumeState.ts